import { createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  contrastRatio: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '16px',
    marginTop: '8px',
  },
});
